// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"da57bbbd","592":"868debed","880":"61ff0fad"}[chunkId] + ".chunk.css";
};